(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("bvue-gmap", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["bvue-gmap"] = factory(require("vue"));
	else
		root["bvue-gmap"] = factory(root["vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_52__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition